var _style, _circle, _path, _circle2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D80027;}\n\t.st1{fill:#FFDA44;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M381.2,256L330,280.1l27.2,49.5L301.7,319l-7,56.1L256,333.8l-38.7,41.3l-7-56.1l-55.5,10.6l27.2-49.5 L130.8,256l51.2-24.1l-27.2-49.5l55.5,10.6l7-56.1l38.7,41.3l38.7-41.3l7,56.1l55.6-10.6L330,231.9L381.2,256z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 77.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217,256c-1.9,0-3.7,0.1-5.6,0.3c0.1,10.8,4,20.7,10.4,28.3c3.4-9.3,8.6-17.7,15.1-24.9 C230.8,257.3,224.1,256,217,256L217,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241,297.9c4.7,1.7,9.7,2.6,15,2.6s10.3-0.9,15-2.6c-2.6-10-7.8-19-15-26C248.8,279,243.6,287.9,241,297.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M294.6,233.7c-7.7-13.3-22.1-22.3-38.6-22.3s-30.9,9-38.6,22.3c14,0.1,27.2,3.9,38.6,10.5 C267.4,237.6,280.5,233.8,294.6,233.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275,259.7c6.5,7.2,11.6,15.7,15.1,24.9c6.4-7.7,10.4-17.5,10.4-28.3c-1.8-0.2-3.7-0.3-5.6-0.3 C287.9,256,281.2,257.3,275,259.7L275,259.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKg);
export default __webpack_public_path__ + "static/media/kg.ea7e29b57c3d248d72752eccf0a285cd.svg";
export { ForwardRef as ReactComponent };